import * as SpeechSDK from "microsoft-cognitiveservices-speech-sdk";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from "@angular/core";
import { catchError, timestamp } from "rxjs";

export enum TranslationMode {
    ENABLED,
    // MIXED,
    DISABLED
  }


@Injectable({
    providedIn: 'root'
})
export class AudioTranslatorService {

    isFirefox: boolean;

    audioContext!: AudioContext;
    localMediaStream: MediaStream | null = null;
    sourceNode!: MediaStreamAudioSourceNode;
    destinationNode!: MediaStreamAudioDestinationNode;


    remoteAudioContext!: AudioContext;
    remoteMediaStream: MediaStream | null = null;
    remoteSourceNode!: MediaStreamAudioSourceNode;
    remoteDestinationNode!: MediaStreamAudioDestinationNode;
    backendUrl!: string;

    localSessionTimeout: any | null = null;
    remoteSessionTimeout: any | null = null;
    tenantId: string = "undefined";
    connectionId: string = "undefined";

    

    constructor(
        private http: HttpClient
    ) {
        this.isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
    }

    setTenantAndConnection( tenantId: string, connectionId: string) {
        this.tenantId = tenantId;
        this.connectionId = connectionId;
    }

    setBackendUrl(url: string) {
      this.backendUrl = url;
    }

    setupLocalAudioGraph(localMediaStream: MediaStream) {
        
        return new Promise<MediaStream>((resolve, reject) => {
            if (!this.audioContext) {
                this.audioContext = new AudioContext();
            }
            this.localMediaStream = localMediaStream;
            setTimeout(() => {
                if (this.localMediaStream === null) {
                    reject('No media stream');
                    return;
                }
                // Crea i nodi audio
                if (this.isFirefox && (this.audioContext as any).createMediaStreamTrackSource) {
                    this.sourceNode = (this.audioContext as any).createMediaStreamTrackSource(this.localMediaStream);
                } else {
                    this.sourceNode = this.audioContext.createMediaStreamSource(this.localMediaStream);
                }
                this.destinationNode = this.audioContext.createMediaStreamDestination();
                this.sourceNode?.connect(this.destinationNode);

                resolve(this.destinationNode.stream);
            }, 200);
        })
    }


    public addRemoteStream(stream: MediaStream | MediaStreamTrack) {
        return new Promise<MediaStream>(async (resolve, reject) => {
            if(stream instanceof MediaStreamTrack) {
              this.remoteMediaStream = new MediaStream([stream]);
            } else {
              this.remoteMediaStream = stream;
            }
          if (!this.remoteAudioContext) {
            this.remoteAudioContext = new AudioContext();
          }
          const s = await this.setupRemoteAudioGraph();
          setTimeout(() => {
            resolve(s);
          }, 500);
        })
      }

      private setupRemoteAudioGraph() {
        return new Promise<MediaStream>((resolve, reject) => {
    
          setTimeout(() => {
    
            if (this.remoteMediaStream === null) {
              reject('No media stream');
              return;
            }
    
            var audio = new Audio();
            audio.srcObject = this.remoteMediaStream;
            this.remoteDestinationNode = this.remoteAudioContext.createMediaStreamDestination();
    
            audio.onloadedmetadata = () => {
              if (audio.srcObject === null) {
                return;
              }
              if (this.isFirefox && (this.remoteSourceNode as any).createMediaStreamTrackSource) {
                this.remoteSourceNode = (this.remoteAudioContext as any).createMediaStreamTrackSource(audio.srcObject as MediaStream);
              } else {
                this.remoteSourceNode = this.remoteAudioContext.createMediaStreamSource(audio.srcObject as MediaStream);
              }
              audio.play();
              audio.muted = true;
              this.remoteSourceNode.connect(this.remoteDestinationNode);
              resolve(this.remoteDestinationNode.stream);
            }
          }, 200);
        })
    
      }

      useLocalAuthorizationRetriever = false;
      authorizationToken: string | null = null;
      sourceLanguage!: string;
      targetLanguage!: string;
      localReco: SpeechSDK.TranslationRecognizer | undefined;
      remoteReco: SpeechSDK.TranslationRecognizer | undefined;


      retrieveAuthorizationToken(isLocal: boolean) {
        return new Promise<{ token: string, region: string }>((resolve, reject) => {
          if (this.useLocalAuthorizationRetriever) {
    
            const speechKey = '3xotjrYrNM6TESa4hXDfEKd9AQtKrdNz8lunAhgFYlIaHLTgFY0XJQQJ99ALAC5T7U2XJ3w3AAAYACOGF3jg';
            const speechRegion = 'francecentral';
            const headers: HttpHeaders = new HttpHeaders({
              'Ocp-Apim-Subscription-Key': speechKey,
              'Content-Type': 'application/x-www-form-urlencoded'
            })
    
              this.http.post(`https://${speechRegion}.api.cognitive.microsoft.com/sts/v1.0/issueToken`, null, {headers, responseType: 'text'}).subscribe((tokenResponse: any) => {
                console.log(tokenResponse);
                this.sendInfoToServer({
                  type: "tokenRequired",
                  sessionId: tokenResponse.token,
                  isLocal: isLocal,
                  timestamp: Date.now()
                })
                resolve({token: tokenResponse, region: speechRegion});  
              });
    
          } else {
            this.http.post(this.backendUrl + '/backoffice/get-speech-token',
              {
                isLocal: isLocal,
                connectionId: this.connectionId,
                tenantId: this.tenantId
              }
            )
              .pipe(
                catchError((error) => {
                  reject(error);
                  return [];
                })
              )
              .subscribe((res: any) => {
                resolve({token: res.token, region: res.region});
              })
          }
    
        })
      }


      private async startLocalTranslationPipeline() {

        if (!this.localMediaStream) {
          return;
        }
    
        const ret  = await this.retrieveAuthorizationToken(true);
        this.authorizationToken = ret.token;
    
    
        // Configura Speech Translation
        const speechConfig = SpeechSDK.SpeechTranslationConfig.fromAuthorizationToken(
          this.authorizationToken,
          ret.region
        );
    
    
        speechConfig.speechRecognitionLanguage = this.sourceLanguage.substring(0, 5);
        speechConfig.addTargetLanguage(this.targetLanguage.substring(0, 5));
        speechConfig.speechSynthesisLanguage = this.targetLanguage;
        speechConfig.voiceName = this.targetLanguage;
    
    
        // const audioConfig = SpeechSDK.AudioConfig.fromDefaultMicrophoneInput();
        const audioConfig = SpeechSDK.AudioConfig.fromStreamInput(this.localMediaStream);
    
        this.localReco = new SpeechSDK.TranslationRecognizer(speechConfig, audioConfig);
    
        this.applyCommonConfigurationTo(this.localReco);
    
        // Additive in TranslationRecognizer, the 'synthesizing' event signals that a payload chunk of synthesized
        // text-to-speech data is available for playback.
        // If the event result contains valid audio, it's reason will be ResultReason.SynthesizingAudio
        // Once a complete phrase has been synthesized, the event will be called with
        // ResultReason.SynthesizingAudioComplete and a 0-byte audio payload.
        this.localReco.synthesizing = this.onSynthesizing.bind(this);
    
        // Start the continuous recognition. Note that, in this continuous scenario, activity is purely event-
        // driven, as use of continuation (as is in the single-shot sample) isn't applicable when there's not a
        // single result.
        this.localReco.startContinuousRecognitionAsync();
    
      }

      stopLocalTranslationPipeline() {
        this._stopTranslationPipeline(this.localReco);
        this.localReco = undefined;
      }
    
      stopRemoteTranslationPipeline() {
        this._stopTranslationPipeline(this.remoteReco);
        this.remoteReco = undefined;
      }
    
      _stopTranslationPipeline(reco: SpeechSDK.TranslationRecognizer | undefined) {
        if (reco !== undefined) {
          reco.stopContinuousRecognitionAsync();
          reco.stopContinuousRecognitionAsync(
            () => {
                reco?.close();
                reco = undefined;
            },
            (err) => {
                reco?.close();
                reco = undefined;
            }
        );
        }
      }

      applyCommonConfigurationTo(recognizer: any) {
        recognizer.recognizing = this.onRecognizing.bind(this);
        recognizer.recognized = this.onRecognized.bind(this);
        recognizer.canceled = this.onLocalCanceled.bind(this);
        recognizer.sessionStarted = this.onLocalSessionStarted.bind(this);
        recognizer.sessionStopped = this.onLocalSessionStopped.bind(this);
      }

      onSynthesizing(sender: any, synthesizingEventArgs: any) {
        var audioSize = synthesizingEventArgs.result.audio === undefined ? 0 : synthesizingEventArgs.result.audio.byteLength;
    
        console.log(`(synthesizing) Reason: ${SpeechSDK.ResultReason[synthesizingEventArgs.result.reason]}`
          + ` ${audioSize} bytes\r\n`);
    
        if (synthesizingEventArgs.result.audio && this.audioContext) {
          var source = this.audioContext.createBufferSource();
          this.audioContext.decodeAudioData(synthesizingEventArgs.result.audio, (newBuffer) => {
            source.buffer = newBuffer;
            source.connect(this.destinationNode);
            source.start(0);
          });
        }
      }
    
      onRecognizing(sender: any, recognitionEventArgs: any) {
        var result = recognitionEventArgs.result;
        console.log(`(recognizing) Reason: ${SpeechSDK.ResultReason[result.reason]}`);
      }
    
      onRecognized(sender: any, recognitionEventArgs: any) {
        var result = recognitionEventArgs.result;
        this.onRecognizedResult(result);
      }
    
      onRecognizedResult(result: any) {
    
        console.log(`(recognized)  Reason: ${SpeechSDK.ResultReason[result.reason]}`);
    
        switch (result.reason) {
          case SpeechSDK.ResultReason.NoMatch:
            var noMatchDetail = SpeechSDK.NoMatchDetails.fromResult(result);
            console.log(`(recognized) NoMatchReason: ${SpeechSDK.NoMatchReason[noMatchDetail.reason]}`);
            break;
          case SpeechSDK.ResultReason.Canceled:
            var cancelDetails = SpeechSDK.CancellationDetails.fromResult(result);
            console.log(`(recognized) CancellationReason: ${SpeechSDK.CancellationReason[cancelDetails.reason]}`);
            break;
          case SpeechSDK.ResultReason.RecognizedSpeech:
          case SpeechSDK.ResultReason.TranslatedSpeech:
          case SpeechSDK.ResultReason.RecognizedIntent:
    
            if (result.json) {
              var detailedResultJson = JSON.parse(result.json);
              var displayText = detailedResultJson['DisplayText'];
              console.log(`Detailed result for "${displayText}":\r\n`
                + `${JSON.stringify(detailedResultJson, null, 2)}\r\n`);
            } else {
              console.log(`${result.text}\r\n`);
            }
    
            var intentJson = result.properties
              .getProperty(SpeechSDK.PropertyId.LanguageUnderstandingServiceResponse_JsonResult);
            if (intentJson) {
              console.log(intentJson);
            }
    
            if (result.translations) {
              var resultJson = JSON.parse(result.json);
              resultJson['privTranslationPhrase']['Translation']['Translations'].forEach(
                (translation: any) => {
                  console.log(`[${translation.Language}] ${translation.Text}`);
                });
            }
            break;
        }
      }
    
      onLocalSessionStarted(sender: any, sessionEventArgs: any) {
        console.log("(sessionStarted) SessionId: " + sessionEventArgs.sessionId);
        this.sendInfoToServer({
          type: "sessionStarted",
          sessionId: sessionEventArgs.sessionId,
          isLocal: true,
          timestamp: Date.now(),
          sourceLanguage: this.sourceLanguage,
          targetLanguage: this.targetLanguage
        });

        this.setLocalSessionTimeout(sessionEventArgs.sessionId);
      }

      setLocalSessionTimeout(sessionId: string) {
        if(this.remoteSessionTimeout) {
          clearTimeout(this.remoteSessionTimeout);
        }

        this.localSessionTimeout = setTimeout(() => {
          this.sendInfoToServer({
            type: "sessionWorking",
            sessionId: sessionId,
            isLocal: true,
            timestamp: Date.now()
          })
          this.setLocalSessionTimeout(sessionId);
        }, 10000);
      }
    
      onLocalSessionStopped(sender: any, sessionEventArgs: any) {
        console.log("(sessionStopped) SessionId: " + sessionEventArgs.sessionId);
        if(this.localSessionTimeout) {
          clearTimeout(this.localSessionTimeout);
        }
        this.sendInfoToServer({
          type: "sessionStopped",
          sessionId: sessionEventArgs.sessionId,
          isLocal: true,
          timestamp: Date.now()
        })
      }

      onLocalCanceled(sender: any, cancellationEventArgs: any) {
        console.log(cancellationEventArgs);
    
        console.log("(cancel) Reason: " + SpeechSDK.CancellationReason[cancellationEventArgs.reason]);
        if (cancellationEventArgs.reason === SpeechSDK.CancellationReason.Error) {
          console.log(cancellationEventArgs.errorDetails);
        }
    
        this.sendInfoToServer({
          type: "cancel",
          reason: cancellationEventArgs.reason,
          errorDetails: cancellationEventArgs.errorDetails,
          isLocal: true,
          timestamp: Date.now()
        })
      }

      onRemoteSessionStarted(sender: any, sessionEventArgs: any) {
        console.log("(sessionStarted) SessionId: " + sessionEventArgs.sessionId);
        this.sendInfoToServer({
          type: "sessionStarted",
          sessionId: sessionEventArgs.sessionId,
          isLocal: false,
          timestamp: Date.now(),
          sourceLanguage: this.targetLanguage,
          targetLanguage: this.sourceLanguage
        })

        this.setRemoteSessionTimeout(sessionEventArgs.sessionId);
      }

      setRemoteSessionTimeout(sessionId: string) {
        if(this.remoteSessionTimeout) {
          clearTimeout(this.remoteSessionTimeout);
        }

        this.remoteSessionTimeout = setTimeout(() => {
          this.sendInfoToServer({
            type: "sessionWorking",
            sessionId: sessionId,
            isLocal: false,
            timestamp: Date.now()
          })
          this.setRemoteSessionTimeout(sessionId);
        }, 10000);
      }

    
      onRemoteSessionStopped(sender: any, sessionEventArgs: any) {
        console.log("(sessionStopped) SessionId: " + sessionEventArgs.sessionId);
        if(this.remoteSessionTimeout) {
          clearTimeout(this.remoteSessionTimeout);
        }
        this.sendInfoToServer({
          type: "sessionStopped",
          sessionId: sessionEventArgs.sessionId,
          isLocal: false,
          timestamp: Date.now()
        })
      }

      onRemoteCanceled(sender: any, cancellationEventArgs: any) {
        console.log(cancellationEventArgs);
    
        console.log("(cancel) Reason: " + SpeechSDK.CancellationReason[cancellationEventArgs.reason]);
        if (cancellationEventArgs.reason === SpeechSDK.CancellationReason.Error) {
          console.log(cancellationEventArgs.errorDetails);
        }
    
        this.sendInfoToServer({
          type: "cancel",
          reason: cancellationEventArgs.reason,
          errorDetails: cancellationEventArgs.errorDetails,
          isLocal: false,
          timestamp: Date.now()
        })
      }

      sendInfoToServer(info: any) {
        if(info) {
          info.tenantId = this.tenantId,
          info.connectionId = this.connectionId
        }
        // TODO: inviare il messaggio al backend
        this.http.post(this.backendUrl + '/backoffice/speech-log', info)
        .pipe(
          catchError(error => {
            console.log(error);
            return error;
          })
        )
        .subscribe();
      }
    
      
    
    
    
      private async startRemoteTranslationPipeline() {
    
        if (!this.remoteMediaStream) {
          return;
        }
    
        const authRet = await this.retrieveAuthorizationToken(false);
    
    
        // Configura Speech Translation
        const speechConfig = SpeechSDK.SpeechTranslationConfig.fromAuthorizationToken(
          authRet.token,
          authRet.region
        );
    
        speechConfig.speechRecognitionLanguage = this.targetLanguage.substring(0, 5);
        speechConfig.addTargetLanguage(this.sourceLanguage.substring(0, 5));
        speechConfig.speechSynthesisLanguage = this.sourceLanguage;
        speechConfig.voiceName = this.sourceLanguage;
    
    
        // const audioConfig = SpeechSDK.AudioConfig.fromDefaultMicrophoneInput();
        const audioConfig = SpeechSDK.AudioConfig.fromStreamInput(this.remoteMediaStream);
    
        this.remoteReco = new SpeechSDK.TranslationRecognizer(speechConfig, audioConfig);
    
    
        this.remoteReco.recognizing = this.onRecognizing.bind(this);
        this.remoteReco.recognized = this.onRecognized.bind(this);
        this.remoteReco.sessionStarted = this.onRemoteSessionStarted.bind(this);
        this.remoteReco.sessionStopped = this.onRemoteSessionStopped.bind(this);
        this.remoteReco.canceled = this.onRemoteCanceled.bind(this);
    
        // Additive in TranslationRecognizer, the 'synthesizing' event signals that a payload chunk of synthesized
        // text-to-speech data is available for playback.
        // If the event result contains valid audio, it's reason will be ResultReason.SynthesizingAudio
        // Once a complete phrase has been synthesized, the event will be called with
        // ResultReason.SynthesizingAudioComplete and a 0-byte audio payload.
        this.remoteReco.synthesizing = this.onRemoteSynthesizing.bind(this);
    
        // Start the continuous recognition. Note that, in this continuous scenario, activity is purely event-
        // driven, as use of continuation (as is in the single-shot sample) isn't applicable when there's not a
        // single result.
        this.remoteReco.startContinuousRecognitionAsync();
      }
    
      onRemoteSynthesizing(sender: any, synthesizingEventArgs: any) {
        var audioSize = synthesizingEventArgs.result.audio === undefined ? 0 : synthesizingEventArgs.result.audio.byteLength;
    
        console.log(`(synthesizing) Reason: ${SpeechSDK.ResultReason[synthesizingEventArgs.result.reason]}`
          + ` ${audioSize} bytes\r\n`);
    
        if (synthesizingEventArgs.result.audio && this.remoteAudioContext) {
          var source = this.remoteAudioContext.createBufferSource();
          this.remoteAudioContext.decodeAudioData(synthesizingEventArgs.result.audio, (newBuffer) => {
            source.buffer = newBuffer;
            source.connect(this.remoteDestinationNode);
            source.start(0);
          });
        }
      }
    
      async audioTranslationStarted() {
    
        console.log("ProcessAudio");
        // TODO: cosa si deve fare???
      }
    
      async remoteAudioTranslationStarted() {
        // this.processor = this.audioContext.createScriptProcessor(this.bufferSize, 1, 1);
        console.log("ProcessAudio");
    
      }
    
      async onLocalTranslationModeChange(mode: TranslationMode) {
        if (mode === TranslationMode.DISABLED) {
          // Reset alla configurazione base
          this.sourceNode.disconnect();
    
          this.sourceNode.connect(this.destinationNode);
    
          // TODO: stoppare eventualmente il riconoscimentot ramite azure
          this.stopLocalTranslationPipeline();
    
        } else {
          // Avvia la pipeline di traduzione per ENABLED e MIXED
          await this.startLocalTranslationPipeline();
        }
      }
    
      async onRemoteTranslationModeChange(mode: TranslationMode) {
        if (mode === TranslationMode.DISABLED) {
          // Reset alla configurazione base
          this.remoteSourceNode.disconnect();
    
          this.remoteSourceNode.connect(this.remoteDestinationNode);
    
          this.stopRemoteTranslationPipeline();
    
    
        } else {
          // Avvia la pipeline di traduzione per ENABLED e MIXED
          await this.startRemoteTranslationPipeline();
        }
      }
    
      onSourceLanguageChange(sourceLanguage: string) {
        this.sourceLanguage = sourceLanguage
      }
    
      onTargetLanguageChange(targetLanguage: string) {
        this.targetLanguage = targetLanguage
      }
    

    
      languages: { value: string; label: string }[] = [
        { value: 'it-IT-CataldoNeural', label: 'Italian' },
        { value: 'en-GB-RyanNeural', label: 'English' },
        { value: 'en-US-AndrewNeural', label: 'American' },
        { value: 'de-DE-BerndNeural', label: 'German' },
        { value: 'es-ES-ElviraNeural', label: 'Spanish' },
        { value: 'fr-FR-ClaudeNeural', label: 'French' },
        // { value: 'hi-IN', label: 'Hindi' },
        // { value: 'ja-JP', label: 'Japanese' },
        // { value: 'ko-KR', label: 'Korean' },
        { value: 'pt-BR-AntonioNeural', label: 'Portuguese' },
        { value: 'ru-RU-DmitryNeural', label: 'Russian' },
        // { value: 'zh-CN', label: 'Mandarin' }
      ];
    
      getLanguages() {
        return this.languages;
      }
}